export default function TwoDecimalFormatter(number) {
    if (number === undefined) {
        return 0;
    }
    return number.toFixed(2);
}